import moment, { MomentInput } from 'moment';

export const calcAge = (birthDay: MomentInput) =>
  moment().diff(birthDay, 'years');
